import { getExportCardsApi } from "./getExportCardsApi";

export const getExportCardsSetData = async (
  lang,
  setMessageResponse,
  cookies,
  setCardsData,
  userId
) => {
  const response = await getExportCardsApi(lang, cookies, userId);
  if (response.success) {
    setCardsData(() => response.res.data.data);
  } else {
    const error = response.res;
    if (error.response) {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: error.response.data.message,
        isShow: true,
      }));
    } else {
      setMessageResponse((prev) => ({
        ...prev,
        success: false,
        message: "Timeout",
        isShow: true,
      }));
    }
  }
};
